import React, { useState, useEffect } from "react";
import { Sidebar } from "primereact/sidebar";
import { Dialog } from "primereact/dialog";
import consentImage from "../../../assets/images/consent_icon.svg";
import consentImageNeeded from "../../../assets/images/constent_needed.svg";
import consent_small from "../../../assets/images/consent_small.svg";
import thankyouconsent from "../../../assets/images/thankyouconsent.svg";
import "./ConsentNeeded.css";

export default function ConsentCard({ bookingId, onApiSubmit, isConsented = false }) {
  const [isChecked, setIsChecked] = useState(isConsented);
  const [isDisabled, setIsDisabled] = useState(isConsented);
  const [isLoading, setIsLoading] = useState(false);
  const [showReadMoreModal, setShowReadMoreModal] = useState(false);
  // Track screen size dynamically for window resizes
  const theme = localStorage.getItem("theme");
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 575 : false
  );

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 575);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Sync internal state if parent passes pre-existing consent status
  useEffect(() => {
    if (isConsented) {
      setIsChecked(true);
      setIsDisabled(true);
    }
  }, [isConsented]);

  const handleToggleChange = async (e) => {
    if (isDisabled) return;

    const checked = e.target.checked;

    if (checked) {
      setIsLoading(true);
      try {
        const payload = {
          consent: true,
          bookingId: bookingId || localStorage.getItem("transid"),
        };

        if (onApiSubmit) {
          await onApiSubmit(payload);
        } else {
          await new Promise((resolve) => setTimeout(resolve, 800));
        }

        setIsChecked(true);
        setIsDisabled(true); // Disable input upon success
        setShowThankYouModal(true); // Display success modal
      } catch (error) {
        console.error("Consent API call failed:", error);
        setIsChecked(false);
      } finally {
        setIsLoading(false);
      }
    }
  };

  // Shared content for Read More popup
  const renderReadMoreContent = () => (
    <div className="consent-modal-container">
      {isMobile && <div className="drag-handle-bar"></div>}
      <h3 className="consent-modal-title">Consent Needed</h3>

      <div className="consent-illustration">
        <img src={consentImageNeeded} alt="consent illustration" />
      </div>

      <div className="consent-info-box">
        <div className="consent-info-icon">
          <img src={consent_small} alt="shield icon" />
        </div>
        <div className="consent-info-text">
          <strong>What you're agreeing to:</strong>
          <p>
            I consent PVR INOX to share my details with the artist to receive updates, promotional offers about the artist and their current and upcoming performance.
          </p>
        </div>
      </div>

      <button
        type="button"
        className={`pvr-primary-btn isMobile ${!isMobile ? "thankyou-btn" : ""}`}
        style={{
          background: theme === "inoxTheme" ? "#234B9E" : '',
          color: theme === "inoxTheme" ? "#fff" : ''
        }}
        onClick={() => setShowReadMoreModal(false)}
      >
        Close
      </button>
    </div>
  );

  return (
    <>
      {/* CARD COMPONENT */}
      <div className="consent-card-wrapper">
        <div className="consent-card-icon">
          <img src={consentImage} alt="consent icon" />
        </div>

        <div className="consent-card-content">
          <h3 className="consent-card-title">Consent Needed</h3>
          <p className="consent-card-desc">
            I consent PVR INOX to share my details with the artist to receive update...
            <button
              type="button"
              className="consent-read-more-btn"
              onClick={() => setShowReadMoreModal(true)}
            >
              Read More
            </button>
          </p>
        </div>

        {/* Toggle Switch */}
        <label className="pvr-switch-label">
          <input
            type="checkbox"
            checked={isChecked}
            disabled={isLoading || isDisabled}
            onChange={handleToggleChange}
            className="pvr-switch-input"
          />
          <span
            className={`pvr-slider 
  ${isChecked ? "active" : ""} 
  ${isLoading || isDisabled ? "disabled" : ""} 
  ${theme === "inoxTheme" ? "pvrinox" : ""}
`} >
            <span className="pvr-slider-thumb" />
          </span>
        </label>
      </div>

      {/* POPUP 1: READ MORE (Bottom Sheet for Mobile, Centered Modal for Desktop) */}
      {isMobile ? (
        <Sidebar
          visible={showReadMoreModal}
          showCloseIcon={false}
          showHeader={false}
          position="bottom"
          onHide={() => setShowReadMoreModal(false)}
          className="consent-sidebar-popup"
          dismissable={true}
        >
          {renderReadMoreContent()}
        </Sidebar>
      ) : (
        <Dialog
          visible={showReadMoreModal}
          onHide={() => setShowReadMoreModal(false)}
          showHeader={false}
          className="consent-desktop-dialog"
          dismissableMask={true}
        >
          {renderReadMoreContent()}
        </Dialog>
      )}
    </>
  );
}